import { BillingSchedule } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1370. 請求予定編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/billing_schedules/:billing_schedule_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  billing_schedule_id: number;
  year_month: string;
  monthly_amount?: number;
  spot_amount?: number;
};

const updateBillingSchedule = (props: Props): Promise<BillingSchedule> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/billing_schedules/${props.billing_schedule_id}`,
    props
  );
};

export const useUpdateBillingSchedule = () => {
  return useMutation({
    mutationFn: updateBillingSchedule
  });
};